// ( async()=> {
//   const settings = {
//     url: "https://crocs-shop-colombia.myshopify.com/api/2025-01/graphql.json",
//     headers: {
//         "X-Shopify-Storefront-Access-Token": "7c439456355873ca55d7eed4dfd66e15",
//         "Content-Type": "application/json"
//     }
//   }

//   const variables = {
//     "id": "gid://shopify/Collection/415041650921"
//   } 

//   const query = `
//     query GetCollectionWithProducts($id: ID!) {
//       collection(id: $id) {
//         products(first: 100) {
//           nodes {
//             title
//             variants(first: 100) {
//               nodes {
//                   id
//                   title
//                   metafields(identifiers: [
//                     { namespace: "locations", key: "available" },
//                     { namespace: "locations", key: "inventory" }
//                   ]) {
//                     namespace
//                     key
//                     value
//                   }
//                 }
//               }
//             }
//           pageInfo {
//             hasNextPage
//             hasPreviousPage
//           }
//         }
//       }
//     }`;

//     // Crear el cuerpo de la solicitud JSON
//     const body = JSON.stringify({
//         query,
//         variables
//     });

//     // --- 3. Ejecución de la Solicitud (Fetch) ---
//     try {
//         console.log("Enviando solicitud GraphQL a Shopify...");
        
//         const response = await fetch(settings.url, {
//             method: 'POST',
//             headers: settings.headers,
//             body: body
//         });

//         // Verificar el estado HTTP
//         if (!response.ok) {
//             // Un error HTTP indica un problema con la conexión o el servidor
//             throw new Error(`Error HTTP: ${response.status} ${response.statusText}`);
//         }

//         const data = await response.json();


        
//         // --- 4. Mostrar Resultados ---
        
//         // Verificar si Shopify devolvió errores de GraphQL
//         if (data.errors) {
//             console.error("⚠️ La solicitud se completó, pero Shopify reportó errores de GraphQL:", data.errors);
//             // Mostrar los datos disponibles si los hay
//             if (data.data) {
//                 console.log("Datos parciales:", data.data);
//             }
//             return;
//         }

//         console.log("✅ Solicitud GraphQL exitosa. Datos de la colección recibidos:");
//         // Puedes procesar 'data.data.collection.products.nodes' aquí
//         console.log(data.data.collection.products.nodes.length + " productos encontrados.");
//         console.log(data.data);

        
//         const storeSelected = (JSON.parse(localStorage.getItem('locationUserSettings'))?.store || '').trim() || 'Envío a domicilio';


//         const products = data.data.collection.products.nodes.map(product => {
//             // 1. Iterar sobre las variantes de cada producto
//             const variants = product.variants.nodes.filter(variant => {
//                 // 2. Buscar el metafield "available" dentro de los metafields de la variante
//                 const availableMetafield = variant.metafields.find(metafield => 
//                     metafield && 
//                     metafield.namespace === 'locations' && 
//                     metafield.key === 'available'
//                 );

//                 if (availableMetafield && availableMetafield.value) {
//                     try {
//                         // El valor es un string de un array JSON, hay que parsearlo.
//                         // Usamos JSON.parse para convertir el string de array en un array real.
//                         const availableLocations = JSON.parse(availableMetafield.value);

//                         // 3. Comprobar si la ubicación deseada está en la lista
//                         // Usamos .includes() para ver si el array de ubicaciones contiene la ubicación.
//                         return availableLocations.includes(storeSelected);
//                     } catch (e) {
//                         // Opcional: manejar errores de parseo si el formato del JSON es incorrecto
//                         console.error("Error al parsear el valor de locations.available:", availableMetafield.value, e);
//                         return false;
//                     }
//                 }
//                 return false;
//             });

//             // 4. Devolver un nuevo objeto de producto solo con las variantes que cumplen el criterio
//             if (variants.length > 0) {
//                 return {
//                     title: product.title,
//                     variants: {
//                         nodes: variants
//                     }
//                 };
//             }
//             return null; // El producto no tiene variantes disponibles en esa ubicación
//         }).filter(product => product !== null); // 5. Filtrar los productos que no tienen variantes disponibles

//         // Muestra el resultado
//         console.log(products);

//         if(products.length > 0 ) {

//           // const targetContainer = document.getElementById('css-slider-swipper');

//           // products.forEach( async (product) => {
//           //   const productHandle = product.handle; 
            
//           //   // El 'fetch' va a la URL del producto, usando la vista alternativa 'ajax'
//           //   const liquidEndpoint = `/products/${productHandle}?view=ajax`; 

//           //   try {
//           //       const response = await fetch(liquidEndpoint);
//           //       if (!response.ok) throw new Error('Error al obtener la tarjeta Liquid');

//           //       const result = await response.json();
                
//           //       if (result.html) {
//           //           // 3. INYECTAR EL HTML en el contenedor
//           //           targetContainer.insertAdjacentHTML('beforeend', result.html);
//           //       }
                
//           //   } catch (error) {
//           //       console.error("❌ Error al procesar la tarjeta:", error);
//           //   }
//           // })
//         }



//     } catch (error) {
//         console.error("❌ Error grave al ejecutar la solicitud:", error);
//     }

// })();


/* Jibbitz Cross Selling Swiper */

document.addEventListener('DOMContentLoaded', ()=> {

    const params = new URLSearchParams(window.location.search);
    // Asumimos que 'locationFilter' es el valor que debe coincidir con la ubicación disponible
    const locationFilter = params.get('storeSelected'); 

    const sliderContainer = document.getElementById('css-slider-swipper');
    const allSlides = sliderContainer ? sliderContainer.querySelectorAll('[data-variant-available-locations]') : [];

    // --- 1. Filtrado y Eliminación del DOM ---
    if (locationFilter) {
        allSlides.forEach((el) => {
          // console.log(el);
          
            // El dataset contiene una cadena de texto, verificamos si incluye la ubicación seleccionada
            if (!el.dataset.variantAvailableLocations.includes(locationFilter)) {
                // el.parentNode.remove(); // Elimina el elemento si NO contiene la ubicación
                 el.closest('.css-swiper-slide')?.remove();
            }
        });
    }

    // --- 2. Recalcular Slides Disponibles ---
    // Volvemos a contar los elementos que quedaron en el DOM.
    // Usamos el mismo selector para el contenedor directo del Swiper.
    const availableSlides = sliderContainer ? sliderContainer.querySelectorAll('[data-variant-available-locations]').length : 0;
    
    // console.log('Slides disponibles después del filtrado:', availableSlides);

    // --- 3. Inicializar Swiper ---
    const swiperSelector = '.css-slider-swipper';
    const swiperElement = document.querySelector(swiperSelector);

    if (swiperElement && availableSlides > 0) {
        
        // Ajustamos los parámetros de visualización para que no haya errores si quedan pocos slides
        const maxSlidesView = Math.min(6, availableSlides); 
        
        const jbzSwiper = new Swiper(swiperSelector, {
            // Optional parameters
            init:false,
            direction: 'horizontal',
            slidesPerView: 2, // Base para móviles
            spaceBetween: 8,
            speed: 800,
            
            // Loop solo si hay suficientes slides para llenar la vista + 1
            loop: false, 
            
            // autoplay: availableSlides > 1 ? {
            //     delay: 5000
            // } : false, 
            
            // If we need pagination
            // pagination: {
            //     el: '.css-swiper-pagination',
            //     clickable: true,
            // },
            // Navigation arrows
            navigation: {
                nextEl: '.css-swiper-button-next',
                prevEl: '.css-swiper-button-prev',
            },
            breakpoints: {
                991: {
                    slidesPerView: 2, // Usamos la cantidad recalculada
                    spaceBetween: 8,
                },
                1024: {
                  slidesPerGroup: maxSlidesView,
                  slidesPerView: maxSlidesView, // Usamos la cantidad recalculada
                  spaceBetween: 8,
                },
            },
            on: {
              init: () => {
                console.log('Swiper inicializado');
                // console.log(swiperElement); 
              }
            },
        });

        jbzSwiper.init();

    } else if (availableSlides === 0) {
        console.log('No hay slides disponibles para mostrar');
        // Opcional: ocultar el contenedor completo
        const cssContainer = document.getElementById('css-container');
        if (cssContainer) {
            cssContainer.style.display = 'none';
        }
    } else {
        console.log('El contenedor principal del Swiper no existe en el DOM');
    }

    // --- 4. Lógica de Cerrar ---
    const jbz_container = document.getElementById('css-container');
    const jbz_close_btn = document.getElementById('css-header-close');

    if(jbz_close_btn && jbz_container){
        jbz_close_btn.addEventListener('click', () => {
            console.log('Click en cerrar cross');
            jbz_container.style.display = 'none';
        });
    }  

});
    
    




// class AddJibbitzCross extends HTMLElement {
//     constructor() {   
//       super();
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
//       this.addEventListener('click', (event) => {
//         console.log('JIBBITZ PRUEBA');
//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];
//         var formData = new FormData();
//         formData.append("id", parseInt(this.dataset.idVariant));
//         formData.append("quantity", 1);
        
//         if (this.cart) {
//           formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;
  
//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               console.log(response.status);
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }
  
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener('modalClosed', () => {
//                 setTimeout(() => { this.cart.renderContents(response) });
//               }, { once: true });
//               quickAddModal.hide(true);
//             } else {
//               this.cart.renderContents(response);
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           });
  
//         console.log(config);
//       })
//     }
//   }
  
//   customElements.define('add-cart-jibbitz-cross', AddJibbitzCross);



